const VERSION_KEY = 'app_version'
const CURRENT_VERSION = process.env.APP_VERSION

export async function clearCacheIfVersionChanged() {
	try {
		const savedVersion = localStorage.getItem(VERSION_KEY)

		/**
		 * 배포 된 버전이랑 이전 버전이랑 다를 경우 아래 로직 실행
		 * 1. 캐시 삭제
		 * 2. 서비스워커 해제
		 * 3. 로컬스토리지에 최신 버전 저장
		 * 4. 새로고침
		 */
		if (savedVersion !== CURRENT_VERSION) {
			console.log(`[Cache] Version changed: ${savedVersion} → ${CURRENT_VERSION}`)

			if ('caches' in window) {
				const keys = await caches.keys()
				await Promise.all(keys.map(key => caches.delete(key)))
			}

			if ('serviceWorker' in navigator) {
				const regs = await navigator.serviceWorker.getRegistrations()
				await Promise.all(regs.map(reg => reg.unregister()))
			}

			localStorage.setItem(VERSION_KEY, CURRENT_VERSION)
			window.location.reload()
		}
	} catch (e) {
		console.error('[Cache] Failed to check version:', e)
	}
}
